var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "signature-pad" } },
    [
      _c("vueSignature", {
        ref: "signature",
        staticClass: "form-control",
        attrs: { sigOption: _vm.option, w: "440px", h: "320px" }
      }),
      _c("br"),
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm",
          attrs: { role: "group", "aria-label": "..." }
        },
        [
          _c(
            "button",
            { staticClass: "btn btn-info btn-sm", on: { click: _vm.clear } },
            [_vm._v("Limpiar")]
          ),
          _c(
            "button",
            { staticClass: "btn btn-primary btn-sm", on: { click: _vm.save } },
            [_vm._v("Usar")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }